import React, { useState, useEffect, } from "react";
import {
  Card,
  CardBody,
  Button,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Label,
  Input,
} from "reactstrap";

import { FormGroup } from "components/common";
import { useForm } from "hooks";
import { NotificationManager } from "react-notifications";
import { PayrollClient, ApiClient } from "services";
import { Trans } from "react-i18next";
import moment from "moment";
import { DailyTable } from "./DailyTable";
import { attendanceNotes } from "pages/UserList/modelNames";
import ImportModal from "components/ImportModal";
import { createPortal } from 'react-dom';
import LoadingMsg from "components/common/LoadingMsg";
import { exportDownload } from "services/util";
import { useQuery } from "react-query";
import { Control } from "react-redux-form";
import Select from "react-select";

const ListDaily = ({ t, selectedOrganisation, xero, match, ...props }) => {
  const { Form } = useForm();

  const payrollClient = PayrollClient();
  const apiClient = ApiClient();

  const fixedTime = 8;

  const initial_form = {
    employee_name: '',
    date: '',
    full_month: false,
  }

  const { data: employees } = useQuery('employees', () =>
    payrollClient.get("employees?status=Active&include_all=false")
      .get("data")
  )

  const [searchForm, setSearchForm] = useState(initial_form)
  const [salaryTypeValue, setSalaryTypeValue] = useState('base');
  const [timeForm, setTimeForm] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const [searchTrigger, setSearchTrigger] = useState(false)

  const [isUploading, setIsUploading] = useState(false)

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const uploadFile = async (file) => {
    try {
      setIsUploading(true)
      let selectedFile = file

      const formData = new FormData();

      formData.append('id', selectedOrganisation.id)
      formData.append('file', selectedFile)
      formData.append('salary_type_value', salaryTypeValue)

      await apiClient
        .post('import_bulk_attendance', formData)
        .then(({ data }) => {
          NotificationManager.success(t("Uploaded successfully"));
          setIsUploading(false)
          closeModal()
        })
    } catch (err) {
      NotificationManager.error(t('Error while importing File'));
      setIsUploading(false)
    }
  };

  const _search = window.location.search;
  const params = new URLSearchParams(_search);
  const _pageSize = parseInt(params.get('pageSize') || 25)
  const _page = parseInt(params.get('page')) || 0
  const handleExportReport = () => {
    exportDownload(payrollClient, "attendance_report/list_export", 'Attendance Report.xlsx', { ...searchForm, 'ordering': `time_date`, 'offset': _page, 'limit': _pageSize })
  }

  const _fetchEmployeesAttendance = async (pageIndex, pageSize) => {
    try {
      var attendance = await payrollClient.get('attendance_report', { params: { ...{ 'ordering': `time_date`, 'offset': pageIndex, 'limit': pageSize }, ...searchForm } }).get('data')
      return { ...attendance, items: attendance.results.map((item) => handleDateAndTime(item)) }
    }
    catch (err) {
      console.error(err)
      return "Error at loading attendance report"
    }
  }

  const handleSubmitTimeOut = () => {
    let data = []
    if (selectedRows?.length > 0) {
      selectedRows.forEach((el, idx) => {
        let element = el.original
        let _time_in = timeForm.time_in || element.time_in
        let _time_out = timeForm.time_out || element.time_out
        data.push({ 'id': element.id, 'employee': element.employee_data.id, 'time_date': element.time_date, 'time_in': _time_in, 'time_out': _time_out })
      })
    } else {
      data.push({ 'time_out': timeForm.time_out })
    }
    UpdateTimeInOut(data)
  }

  function UpdateTimeInOut(data) {
    payrollClient
      .put('attendance_report/bulk_edit', data)
      .then(({ data }) => {
        NotificationManager.success(t('Updated Successfully'));
        setSearchTrigger(!searchTrigger)
        modal && setModal(false)
        return true
      })
      .catch((err) => {
        NotificationManager.error(t('Error at updating'));
        return false
      });
  }

  const resetSearchFields = () => {
    setSearchForm(initial_form)
    setSearchTrigger(!searchTrigger)
  }

  const handleDateAndTime = (item) => {
    let duration = null
    let intervallMins
    let start = item.time_in ? moment(item.time_in, "HH:mm:ss") : ""
    let end = item.time_out ? moment(item.time_out, "HH:mm:ss") : ""

    if (start & end) {
      let difference = moment.duration(end.diff(start)) || 0;
      let hours = difference.hours(), minutes = difference.minutes()
      duration = `${hours}h ${minutes}m`
      intervallMins = (fixedTime * 60) - ((hours * 60) + minutes)  //fixed-worked = difference in mins
    }

    item.duration = duration || 0
    item.time_in = start ? start.format("HH:mm") : ""
    item.time_out = end ? end.format("HH:mm") : ""
    item.intervallMins = intervallMins
    return item
  }

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="settingsmanagement">
      {isUploading &&
        createPortal(
          <div className="content">
            <div className="loader"></div>
            {<LoadingMsg />}
          </div>,
          document.querySelector('#loader-holder')
        )}
      <Modal isOpen={modal} toggle={toggle} >
        <ModalHeader toggle={toggle}><Trans>Set Time Out Value</Trans></ModalHeader>
        <ModalBody>
          <Col className="col-md-12 col-xs-12 mb-3">
            <FormGroup>
              <Label htmlFor="time in"><Trans>Time In Value</Trans></Label>
              <Input type="time"
                name="time_in"
                placeholder="e.g. 08:00:00"
                value={timeForm.time_in || ""}
                onChange={(e) => setTimeForm({ ...timeForm, time_in: e.target.value })} />
            </FormGroup>
            <FormGroup className="my-3">
              <Label htmlFor="time out"><Trans>Time Out Value</Trans></Label>
              <Input type="time"
                name="time out"
                placeholder="e.g. 12:00:00"
                value={timeForm.time_out || ""}
                onChange={(e) => setTimeForm({ ...timeForm, time_out: e.target.value })} />
            </FormGroup>
            <Button
              style={{ marginBottom: "10px" }}
              color="success"
              className="bt float-right mt-4"
              type="submit"
              onClick={() => { handleSubmitTimeOut() }}>
              <Trans>Update</Trans>
            </Button>
          </Col>
        </ModalBody>
      </Modal>
      <Row>
        <Col xs="12" md="12" sm="12">
          <Card>
            <CardBody>
              <h4 className="mt-2 mb-4"><Trans>Attendance Report daily</Trans></h4>
              <Row>
                <div className="col-xs-12 col-md-12 pr-0 my-3 px-1">
                  <Form className="form d-flex">
                    <Col className="col-md-3 col-xs-6 mb-3">
                      <FormGroup className="pb-3" label="Employee" model=".employee" addControlClass={false}>
                        <Control.text
                          model=".employee"
                          component={Select}
                          options={employees}
                          onChange={(value) => setSearchForm({ ...searchForm, employee_id: value })}
                          simpleValue
                          clearable={false}
                          valueKey="id"
                          labelKey="full_name"
                          multi
                        />
                      </FormGroup>
                    </Col>
                    <Col className="col-md-3 col-xs-6 mb-3">
                      <FormGroup className="mx-2">
                        <label><Trans>Date</Trans></label>
                        <Input
                          type="date"
                          name="date"
                          className=""
                          value={searchForm.start_date}
                          onChange={(e) => setSearchForm({ ...searchForm, time_date: e.target.value })}
                        />
                      </FormGroup>
                    </Col>
                    <FormGroup check className="d-flex align-items-center mx-2 mb-2">
                      <Input name="full_month" type="checkbox" checked={searchForm.full_month} onChange={(e) => setSearchForm({ ...searchForm, full_month: !searchForm.full_month })} />
                      <Label check htmlFor="full_month"><Trans>Full Month</Trans></Label>
                    </FormGroup>
                    <div className="ml-2" style={{
                      marginTop: "28px"
                    }}>
                      <Button color="success" className="mr-2" onClick={() => setSearchTrigger(!searchTrigger)}><Trans>Search</Trans></Button>
                      <Button className="mr-2" onClick={resetSearchFields}><Trans>Reset</Trans></Button>
                    </div>
                  </Form>
                </div>

                <Col className="col-12 d-flex flex-row justify-content-end align-items-baseline">

                  <Button size="md" disabled={selectedRows?.length <= 0} color="primary" className="mb-2 mt-0 ml-0 float-right" onClick={toggle}> <Trans>Bulk Update</Trans></Button>
                  <div className="d-flex align-items-center" style={{ paddingBottom: 20 }}>
                    <Button className="ml-2" color="primary" onClick={openModal}>
                      <Trans>Import</Trans><span className="mx-1" /><i className="fas fa-file-excel" />
                    </Button>
                    <Button className="mx-0" color="primary" onClick={handleExportReport}>
                      <Trans>Export</Trans><span className="mx-1" /><i className="fas fa-file-excel" />
                    </Button>
                    <ImportModal
                      isOpen={isModalOpen}
                      toggle={closeModal}
                      title="Attendance"
                      importantNotes={attendanceNotes}
                      handleUpload={uploadFile}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <DailyTable t={t} fetch={_fetchEmployeesAttendance} UpdateTimeInOut={UpdateTimeInOut} setSelectedRows={setSelectedRows} refetch={searchTrigger} />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};


export default ListDaily;
